module.exports = __webpack_public_path__ + "img/thumbnail_EuropeanBadger_m_normal.b6dce4fa.png";